module.exports = __webpack_public_path__ + "img/jr_banner_en.df40c46c.jpg";